import { children } from './fmp4-split';
/** Exact sample offsets for our default-base-is-moof fragments. Unsupported layouts fail closed. */
export function videoSamples(bytes: Uint8Array, trackId: number): { decodeTime: number; bytes: Uint8Array }[] {
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const top = children(bytes, 0, bytes.length), moof = top.find(b => b.type === 'moof'), mdat = top.find(b => b.type === 'mdat');
  if (!moof || !mdat) return [];
  for (const traf of children(bytes, moof.body, moof.end).filter(b => b.type === 'traf')) {
    const boxes = children(bytes, traf.body, traf.end), tfhd = boxes.find(b => b.type === 'tfhd'), tfdt = boxes.find(b => b.type === 'tfdt');
    if (!tfhd || !tfdt || view.getUint32(tfhd.body + 4) !== trackId) continue;
    const flags = view.getUint32(tfhd.body) & 0xffffff;
    if (flags & 1) return []; // Absolute offsets are not emitted by this pipeline.
    let cursor = tfhd.body + 8;
    if (flags & 2) cursor += 4;
    const defaultDuration = flags & 8 ? view.getUint32(cursor) : 0; if (flags & 8) cursor += 4;
    const defaultSize = flags & 16 ? view.getUint32(cursor) : 0;
    let time = bytes[tfdt.body] === 1 ? Number(view.getBigUint64(tfdt.body + 4)) : view.getUint32(tfdt.body + 4);
    const result: { decodeTime: number; bytes: Uint8Array }[] = [];
    for (const trun of boxes.filter(b => b.type === 'trun')) {
      const flags = view.getUint32(trun.body) & 0xffffff, count = view.getUint32(trun.body + 4);
      if (!(flags & 1) || count > 600) return [];
      let p = trun.body + 12, offset = moof.start + view.getInt32(trun.body + 8);
      if (flags & 4) p += 4;
      for (let i = 0; i < count; i++) {
        const duration = flags & 0x100 ? view.getUint32(p) : defaultDuration; if (flags & 0x100) p += 4;
        const size = flags & 0x200 ? view.getUint32(p) : defaultSize; if (flags & 0x200) p += 4;
        if (flags & 0x400) p += 4;
        if (flags & 0x800) { if (view.getInt32(p) !== 0) return []; p += 4; }
        if (p > trun.end || duration <= 0 || size <= 0 || offset < mdat.body || offset + size > mdat.end || !Number.isSafeInteger(time)) return [];
        result.push({ decodeTime: time, bytes: bytes.subarray(offset, offset + size) });
        time += duration; offset += size;
      }
    }
    return result;
  }
  return [];
}
